export default __webpack_public_path__ + "static/media/amazon_logo.1c9be0b2.png";